import { render, staticRenderFns } from "./ElCounter.vue?vue&type=template&id=c68cacd4"
import script from "./ElCounter.vue?vue&type=script&lang=js"
export * from "./ElCounter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports